import {makeAutoObservable} from 'mobx';

class UserStore {
    private _user: any = null;
    private _isLoading = false;
    private _error: string | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    get user() {
        return this._user;
    }

    get isLoading() {
        return this._isLoading;
    }

    get error() {
        return this._error;
    }

    get isSignedIn() {
        return !!this._user;
    }

    get idString() {
        return this._user?.profile?.idString;
    }

    get accessToken() {
        return this._user?.access_token;
    }

    updateUser(user: any) {
        // Only update if the user data has actually changed
        if (JSON.stringify(this._user) !== JSON.stringify(user)) {
            this._user = user;
        }
    }

    setLoading(isLoading: boolean) {
        this._isLoading = isLoading;
    }

    setError(error: string | null) {
        this._error = error;
    }

    reset() {
        this._user = null;
        this._isLoading = false;
        this._error = null;
    }
}

export const userStore = new UserStore();
